import { expected } from '@aloft/toolkit-shared';

import { RunMatchSearchResult } from '../matching/types.ts';
import { PairedSaleIDs } from '../types.ts';

export const makePairsFromResult = (params: RunMatchSearchResult): PairedSaleIDs[] => {
  const { output, propsByListingID } = params;

  return output.pairs.map(({ p1, p2 }) => ({
    p1: expected(propsByListingID[p1]?.toolkitRecordID),
    p2: expected(propsByListingID[p2]?.toolkitRecordID),
  }));
};
